import { render, staticRenderFns } from "./PrintableChart.vue?vue&type=template&id=5c9064f2&scoped=true"
import script from "./PrintableChart.vue?vue&type=script&lang=js"
export * from "./PrintableChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9064f2",
  null
  
)

export default component.exports